module.exports = __webpack_public_path__ + "static/media/fundo_desintec_armadilhaMosquitoAdulto2.d5cb8604.png";